module.exports = __webpack_public_path__ + "static/media/edit.36798fab.svg";